import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from './ConfirmationModal';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, message, title = "Confirm Delete" }) => {
  const deleteIcon = (
    <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center">
      <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    </div>
  );

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message || "Are you sure you want to delete? This action cannot be undone."}
      confirmButtonText="Delete"
      confirmButtonClass="bg-red-600 hover:bg-red-700 focus:ring-red-500"
      iconComponent={deleteIcon}
    />
  );
};

DeleteConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string
};

export default DeleteConfirmationModal;